/* Metal Memory: language list with flags (header + mobile menu). Progressive enhancement of <details data-mm-lang-menu>. */
(function () {
  if (window.__mmLangMenu) return;
  window.__mmLangMenu = true;

  var SEL = 'details[data-mm-lang-menu]';

  function openMenus() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL + '[open]'));
  }

  function closeAll(except) {
    openMenus().forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (e) {
    openMenus().forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.matches && e.target.matches(SEL) && e.target.open) closeAll(e.target);
  }, true);

  document.addEventListener('focusin', function (e) {
    openMenus().forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    var menu = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (e.key === 'Escape') {
      var open = menu && menu.open ? menu : openMenus()[0];
      if (open) {
        open.removeAttribute('open');
        var s = open.querySelector('summary');
        if (s) s.focus();
      }
      return;
    }
    if (!menu || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    var items = Array.prototype.slice.call(menu.querySelectorAll('.mm-lang-menu__btn'));
    if (!items.length) return;
    if (!menu.open) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        menu.setAttribute('open', '');
        items[0].focus();
      }
      return;
    }
    e.preventDefault();
    var i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') i = i < items.length - 1 ? i + 1 : 0;
    else i = i > 0 ? i - 1 : items.length - 1;
    items[i].focus();
  });
})();
